import DateType from "./DateType";
const plugin = {
    install(components) {
        components.Model.date = function (value, mutator) {
            return new DateType(this, value, mutator);
        };
    },
};
export default plugin;
//# sourceMappingURL=index.js.map